import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import MainFont from 'ui/typography/mainFont';

import {
  ActionButton,
  IconAccept,
  IconDecline,
  Radio,
  RadioButtonLabel,
  RadioContainer,
  RadioItem,
  Text
} from './style';

const CustomRadio = ({
  placeholder,
  value,
  name,
  icon,
  valid,
  readonly,
  autoFocus,
  disabled,
  onFocus,
  padding,
  isEditable,
  onClose,
  onChange,
  onAccept
}) => {
  const [val, setVal] = useState(value);
  useEffect(() => {
    setVal(value);
  }, [value]);

  const updateValue = currValue => {
    const toBool = currValue === 'Yes';
    setVal(currValue);
    if (onChange) onChange(toBool);
  };

  const handleOnFocus = () => {
    if (onFocus) onFocus();
  };

  const handleOnclickDecline = () => {
    setVal(value);
    if (onClose) {
      onClose();
    }
  };
  const handleOnclickAccept = () => {
    if (onAccept) {
      onAccept();
    }
    if (onClose) {
      onClose();
    }
  };

  return (
    <RadioContainer
      valid={readonly || (valid && typeof valid !== 'string')}
      value={value}
      readonly={readonly}
      disabled={disabled}
      padding={padding}
    >
      {!isEditable ? (
        <Text onClick={handleOnFocus}>
          <MainFont configuration={{ fontSize: 16, lineHeight: 1.5 }}>
            {val}
          </MainFont>
        </Text>
      ) : (
        <>
          <RadioItem onClick={() => updateValue('Yes')}>
            <Radio
              autoFocus={autoFocus}
              type="radio"
              placeholder={readonly ? '' : placeholder}
              value="Yes"
              name={name}
              readonly={readonly}
              disabled={disabled}
              icon={icon}
              checked={val === 'Yes'}
            />
            <MainFont>Yes</MainFont>
            <RadioButtonLabel
              className={val === 'Yes' ? 'icon-checkok' : null}
              checked={val === 'Yes'}
            />
          </RadioItem>
          <RadioItem onClick={() => updateValue('No')}>
            <Radio
              autoFocus={autoFocus}
              type="radio"
              placeholder={readonly ? '' : placeholder}
              name={name}
              value="No"
              readonly={readonly}
              disabled={disabled}
              icon={icon}
              checked={val === 'No'}
            />
            <RadioButtonLabel
              className={val === 'No' ? 'icon-checkok' : null}
              checked={val === 'No'}
            />
            <MainFont>No</MainFont>
          </RadioItem>

          <ActionButton>
            <IconDecline
              className="icon-close"
              hasValue={val?.length >= 1}
              onClick={handleOnclickDecline}
            />
            <IconAccept
              className="icon-checkok"
              hasValue={val?.length >= 1}
              onClick={handleOnclickAccept}
            />
          </ActionButton>
        </>
      )}
    </RadioContainer>
  );
};

CustomRadio.propTypes = {
  onAccept: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onClose: PropTypes.func,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  icon: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  valid: PropTypes.bool,
  isEditable: PropTypes.bool,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  autoFocus: PropTypes.bool,
  padding: PropTypes.string
};

CustomRadio.defaultProps = {
  autoFocus: false,
  placeholder: '',
  readonly: false,
  valid: true
};

export default CustomRadio;
